import { render } from "./AddStudentPayment.vue?vue&type=template&id=46623aea&scoped=true"
import script from "./AddStudentPayment.vue?vue&type=script&lang=js"
export * from "./AddStudentPayment.vue?vue&type=script&lang=js"

import "./AddStudentPayment.vue?vue&type=style&index=0&id=46623aea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46623aea"]])

export default __exports__